/** Central feature switches. Flip CASE_STUDIES_ENABLED to true once real case studies are published:
 * it restores navigation links, homepage preview, indexing and sitemap entries together. */
export const CASE_STUDIES_ENABLED = false;
